import { Suspense, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Brand } from './Brand';
import { Sidebar } from './Sidebar';
import { MAIN_ID, SkipLink } from './SkipLink';
import { Icon, Spinner } from '@/components/ui';
import { useDocumentKeydown } from '@/lib/useDocumentKeydown';

/** Authenticated layout: fixed left sidebar on desktop, a drawer on small screens. */
export function AppLayout() {
  const [drawer, setDrawer] = useState(false);
  useDocumentKeydown(drawer, (e) => e.key === 'Escape' && setDrawer(false));
  return (
    <div className="min-h-screen bg-paper text-ink">
      <SkipLink />
      <aside className="fixed inset-y-0 left-0 hidden w-sidebar border-r border-line bg-surface md:block">
        <Sidebar />
      </aside>
      <header className="flex items-center justify-between border-b border-line bg-surface px-4 py-3 md:hidden">
        <Brand />
        <button
          type="button"
          aria-label="Open navigation"
          aria-expanded={drawer}
          onClick={() => setDrawer(true)}
          className="rounded-md p-2 text-ink-soft hover:bg-surface-2 focus-visible:outline focus-visible:outline-2 focus-visible:outline-accent"
        >
          <Icon name="menu" className="h-5 w-5" />
        </button>
      </header>
      {drawer && (
        <div className="fixed inset-0 z-40 md:hidden">
          <div
            className="absolute inset-0 bg-black/60"
            aria-hidden="true"
            onClick={() => setDrawer(false)}
          />
          <aside
            aria-label="Navigation"
            className="absolute inset-y-0 left-0 w-sidebar border-r border-line bg-surface"
          >
            <Sidebar onNavigate={() => setDrawer(false)} />
          </aside>
        </div>
      )}
      <main id={MAIN_ID} tabIndex={-1} className="focus:outline-none md:pl-sidebar">
        <div className="mx-auto max-w-content px-4 py-8 sm:px-8 sm:py-10">
          <Suspense fallback={<Spinner />}>
            <Outlet />
          </Suspense>
        </div>
      </main>
    </div>
  );
}
